import { NewMessageProps, UsersListType } from "@/common/types";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { SquarePen } from "lucide-react";
import { DialogTitle } from "@radix-ui/react-dialog";
import { useDispatch, useSelector } from "react-redux";
import useDebounce from "@/hooks/use-debounce";
import { getUsers } from "@/redux/actions/usersActions";
import { RootState } from "@/redux/reducers";
import { capitalize } from "@/utils/common.util";

const NewMessage: React.FC<NewMessageProps> = ({ handleNewMessage }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [searchTerm, setSearchTerm] = useState<string>("");
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  const { usersList } = useSelector((state: RootState) => state.users);

  const dispatch: any = useDispatch();

  useEffect(() => {
    if (isOpen) dispatch(getUsers({ search: debouncedSearchTerm }));
  }, [isOpen, debouncedSearchTerm]);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger>
        <SquarePen onClick={() => setIsOpen(true)} />
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>New Message</DialogTitle>
        </DialogHeader>
        <Input onChange={(e) => setSearchTerm(e.target.value)} />
        <div className="flex flex-col gap-2 max-h-[300px] overflow-y-auto">
          {(usersList as UsersListType)?.results?.map((user) => (
            <div
              key={user.id}
              className="flex items-center justify-between gap-2 px-4 py-2 hover:bg-gray-100"
              onClick={() => {
                handleNewMessage(user);
                setIsOpen(false);
              }}
            >
              <div className="flex items-center gap-2">
                <div className="text-sm font-medium">{user.name}</div>
              </div>
              <div>
                <div className="text-sm text-gray-500">
                  {capitalize(user.role)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NewMessage;
